import Vue from 'vue'
import Vuex from 'vuex'
import { Stripe } from './../components/vue-stripe/stripeElements';
import ApiService from "../services/serviceApi"

Vue.use(Vuex);

export const BookingStore = new Vuex.Store({
    state: {
        bookingInfo: {
            version: 1,
            currentStep: 1,
            general: {
                guid: '',
                bookingType: 1,
                pickupAddress: {
                    text: "",
                    location: null
                },
                isNotCoveredLocation: false,
                dropOffAddress: {
                    text: "",
                    location: null
                },
                pickupDate: null, // "29-09-2018", //null,
                pickupTime: null, //"16:10",//null,
                durationInHours: 0,
                timeInMinutes: 0,
                distanceInMiles: 0,
                loadPricesFromServer: false, //next state update will request prices from server
                isPriceLoading: false,
                serverPriceErrors: []
            },
            selectedCar: {},
            payment: {
                paymentInProgress: false,
                errors: [],
                stripeThreeDSecureUrl: '',
                stripeThreeDSecureSourceId: '',  //server stripe source 3D secure != than initial one
                threeDSecureInProgress: false,
                done: false,
                stripeSource: {},
                stripeToken: null
            },
            passengerDetails: {
                salutation: '',
                email: '',
                phone: '',
                firstName: '',
                lastName: '',

                adultsNumber: '',
                childrenNumber: '',
                smallChildrenNumber: '',

                hasMeetAndGreet: false,

                largeLuggageNumber: '',
                mediumLuggageNumber: '',

                flightNumber: '',
                comingFrom: '',
                roomNumber: '',
                driverInstructions: '',
                companyName: '',
                companyTaxNumber: '',
                companyAddress: '',
                companyAdditionalAddress: '',

                arrivingByPlane: false,
                differentBilling: false
            },
            mapInfo: {
                visible: true,
                from: null,
                to: null,
                type: 1,
                mapCenter: {
                    lat: window.websiteSettings.mapCenterLat, //51.501527,
                    lng: window.websiteSettings.mapCenterLng,// -0.1921837
                }
            },
            availableCars: []
        },
        configuration: {
            apiKey: window.websiteSettings.apiKey,
            stripeId: window.websiteSettings.stripeId,
            contactPhone: window.websiteSettings.contactPhone,
            country: window.websiteSettings.country,
            companyName: window.websiteSettings.companyName,
            companyTermsAndCondHtml: window.websiteSettings.companyTermsAndCondHtml,

            showCallOnTooClosePickup: window.websiteSettings.showCallOnTooClosePickup,
            showCallOnNotCoveredPickup: window.websiteSettings.showCallOnNotCoveredPickup,

            saveCustomerCardForLaterCharges: false,
            percentageToChargeAtBookingTime: null,
            canConfirmByPhone: false,
            canConfirmByCash: false,
            bookingDurations: [
                { value: 0, text: "Duration" },
                //{ value: 1, text: "1 hour"},
              //  { value: 2, text: "2 hours" },
                { value: 3, text: "3 hours" },
                { value: 4, text: "4 hours" },
                { value: 5, text: "5 hours" },
                { value: 6, text: "6 hours" },
                { value: 7, text: "7 hours" },
                { value: 8, text: "8 hours" },
                { value: 9, text: "9 hours" },
                { value: 10, text: "10 hours" },
                { value: 11, text: "11 hours" },
                { value: 12, text: "12 hours" }
                //{ value: 13, text: "13 hours" },
                //{ value: 14, text: "14 hours" },
                //{ value: 15, text: "15 hours" },
                //{ value: 16, text: "16 hours" },
                //{ value: 17, text: "17 hours" },
                //{ value: 18, text: "18 hours" },
                //{ value: 19, text: "19 hours" },
                //{ value: 20, text: "20 hours" },
                //{ value: 21, text: "21 hours" },
                //{ value: 22, text: "22 hours" },
                //{ value: 23, text: "23 hours" },
                //{ value: 24, text: "24 hours" }
            ]
        },
        count: 0,
        otherForms: {
            showCustomQuoteForm: false,
            showCustomerContactFormModal: false,
            showTermsAndCondModal: false
        },
        uiState: {
            isCreateBookingInProgress: false
        },
        stripeThreeDSecureTimer: null
    },
    actions: {
        goToNextStep(store) {
            var step = store.state.bookingInfo.currentStep;
            store.commit('setCurrentStep', step + 1);
        },
        updateBookingPrice: function (store) {
            //TODO: remove blocker and use debounce  https://stackoverflow.com/questions/42199956/how-to-implement-debounce-in-vue2
            //if (store.state.bookingInfo.general.isPriceLoading) return;
            store.commit('setPriceLoading', true);

            var bookingInfo = store.state.bookingInfo.general;
            var passengerDetails = {};
            passengerDetails.adultsNumber = store.state.bookingInfo.passengerDetails.adultsNumber;
            passengerDetails.childrenNumber = store.state.bookingInfo.passengerDetails.childrenNumber;
            passengerDetails.hasMeetAndGreet = store.state.bookingInfo.passengerDetails.hasMeetAndGreet;

            var bookingInfoModel =
                {
                    apiKey: store.state.configuration.apiKey,
                    carTypeGuid: null, //carTypeId: this.bookingInfoModel.carTypeId, //"1",
                    type: bookingInfo.bookingType,
                    from: bookingInfo.pickupAddress.location,
                    to: bookingInfo.bookingType === 1 ? bookingInfo.dropOffAddress.location : null,
                    durationInHours: bookingInfo.durationInHours,
                    pickupDateTime: bookingInfo.pickupDate + " " + bookingInfo.pickupTime,
                    pickupDateDisplayed: bookingInfo.pickupDate + " " + bookingInfo.pickupTime,
                    promoCode: bookingInfo.promoCode,
                    passengerDetails: passengerDetails
                };

            ApiService.getTripPriceForAllCar(bookingInfoModel).then((response) => {
                //if we have error -> set that TODO: redirect to step 1
                if (!response.data.success) {
                    store.commit('setPriceLoading', false);
                    store.commit('setServerPriceErrors', response.data.errors);
                    if (response.data.result && response.data.result.isNotCovered) {
                        store.commit('setNotCoveredLocation', response.data.result.isNotCovered);
                    }
                    return;
                }

                //price was loaded successfully -> remove errors, update available car list 
                //console.log(JSON.stringify(response.data.result.cars, null, 2));
                store.commit('setNotCoveredLocation', false);
                store.commit('setServerPriceErrors', []);
                store.state.bookingInfo.availableCars.length = 0;
                response.data.result.cars.forEach(function (item) {
                    store.state.bookingInfo.availableCars.push(item);
                    //if current item is the selected one, update selected item to reflect price change
                    if (store.state.bookingInfo.selectedCar && store.state.bookingInfo.selectedCar.guid === item.guid) {
                        store.state.bookingInfo.selectedCar = item;
                    }
                });

                var bookingState = store.state.bookingInfo;
                localStorage.setItem('bookingInfoGeneral', JSON.stringify(bookingState));
                if (store.state.nextRedirect) {
                    window.location.href = store.state.nextRedirect;
                    return;
                }

                //in case of a restore -> state restoration will take care of setting this correctly
                store.commit('setPriceLoading', false);
            }).catch(error => {
                console.log("call failed", error);
                store.commit('setPriceLoading', false);
                store.commit('setServerPriceErrors', ["We could not load available cars for your trip. Please try again."]);
            });
        },
        getBookingPrice: function (store) {
            if (store.state.bookingInfo.general.isPriceLoading) return;
            store.commit('setPriceLoading', true);

            var bookingInfo = store.state.bookingInfo.general;
            var passengerDetails = {};
            passengerDetails.childrenNumber = store.state.bookingInfo.passengerDetails.childrenNumber;
            passengerDetails.hasMeetAndGreet = store.state.bookingInfo.passengerDetails.hasMeetAndGreet;
            var bookingInfoModel =
                {
                    apiKey: store.state.configuration.apiKey,
                    carTypeGuid: null, //carTypeId: this.bookingInfoModel.carTypeId, //"1",
                    type: bookingInfo.bookingType,
                    from: bookingInfo.pickupAddress.location,
                    to: bookingInfo.bookingType === 1 ? bookingInfo.dropOffAddress.location : null,
                    durationInHours: bookingInfo.durationInHours,
                    pickupDateTime: bookingInfo.pickupDate + " " + bookingInfo.pickupTime,
                    pickupDateDisplayed: bookingInfo.pickupDate + " " + bookingInfo.pickupTime,
                    promoCode: bookingInfo.promoCode,
                    passengerDetails: passengerDetails
                };

            ApiService.getTripPriceForAllCar(bookingInfoModel).then((response) => {
                if (!response.data.success) {
                    store.commit('setPriceLoading', false);
                    store.commit('setServerPriceErrors', response.data.errors);
                    if (response.data.result && response.data.result.isNotCovered) {
                        store.commit('setNotCoveredLocation', response.data.result.isNotCovered);
                    }
                    return;
                }
                store.commit('setNotCoveredLocation', false);
                store.commit('setServerPriceErrors', []);
                console.log(JSON.stringify(response.data.result.cars, null, 2));
                store.state.bookingInfo.availableCars.length = 0;
                response.data.result.cars.forEach(function (item) {
                    store.state.bookingInfo.availableCars.push(item);
                });

                store.commit('setCurrentStep', 2);
                if (store.state.nextRedirect) {
                    var bookingState = store.state.bookingInfo;
                    localStorage.setItem('bookingInfoGeneral', JSON.stringify(bookingState));
                    window.location.href = store.state.nextRedirect;
                    return;
                }

                //in case of a restore -> state restoration will take care of setting this correctly
                store.commit('setPriceLoading', false);
            }).catch(error => {
                console.log("call failed", error);
                store.commit('setPriceLoading', false);
                store.commit('setServerPriceErrors', ["We could not load available cars for your trip. Please try again."]);
            });
        },
        createBooking: function (store) {
            store.commit('setIsCreateBookingInProgress', true);
            var bookingInfo = store.state.bookingInfo;
            var bookingInfoModel = {
                hash: bookingInfo.selectedCar
                    ? bookingInfo.selectedCar.hash
                    : null,
                guid: bookingInfo.general.guid,
                paymentMethod: bookingInfo.general.paymentMethod,
                passengerDetails: bookingInfo.passengerDetails,
                stripeSourceId: bookingInfo.payment.stripeSource.id,
                stripeTokenId: bookingInfo.payment.stripeToken
            };
            if (bookingInfo.payment.stripeSource.card && bookingInfo.payment.stripeSource.card.three_d_secure) {
                bookingInfoModel.stripeThreeDSecure = bookingInfo.payment.stripeSource.card.three_d_secure;
            }

            var str = JSON.stringify(bookingInfoModel, null, 2);
            console.log(str);

            ApiService.createBooking(bookingInfoModel).then(
                response => {
                    console.log(response.data);

                    store.commit('setBookingGuid', response.data.result.guid);
                    store.commit('setPaymentInfo',
                        {
                            paymentErrors: response.data.errors,
                            paymentDone: response.data.result.paymentDone,
                            stripeThreeDSecureSourceId: response.data.result.stripeSourceId,
                            stripeThreeDSecureUrl: response.data.result.threeDSecureUrl
                        });

                    if (response.data.result.threeDSecureUrl && response.data.result.threeDSecureUrl.length > 0) {
                        store.dispatch('checkStripeThreeDSecureStatus');
                    } else {
                        store.commit('setPaymentInProgress', false);
                        store.commit('setIsCreateBookingInProgress', false);
                        //TODO: check payment status 
                        //TODO: show errors
                    }
                }).catch(
                error => {
                    console.log(error.response);
                    store.commit('setPaymentInProgress', false);
                    store.commit('setIsCreateBookingInProgress', false);
                    store.commit('setPaymentErrors', ['We could not complete your payment. Please try again.']);
                });
        },
        checkStripeThreeDSecureStatus: function (store) {
            store.commit('setThreeDSecureInProgress', true);

            const timer = store.state.stripeThreeDSecureTimer;
            if (timer) {
                window.clearInterval(timer);
            }
            var executing = false;
            store.state.stripeThreeDSecureTimer = window.setInterval(function () {
                //check and get timer api request lock 
                if (executing) return;
                executing = true;

                var sourceId = store.state.bookingInfo.payment.stripeThreeDSecureSourceId;
                var websiteId = store.state.configuration.apiKey;
                ApiService.checkStripeSourceStatus(sourceId, websiteId).then(response => {
                    console.log(response);
                    if (response.data.result.status === 'chargeable') {
                        //call charge card API
                        var bGuid = store.state.bookingInfo.general.guid;
                        ApiService.chargeBookingWithStripe(bGuid, sourceId).then((response) => {
                            if (response.data.success) {
                                store.commit('setPaymentStatus', response.data.result.payed);
                            } else {
                                //TODO: check for errors here
                                store.commit('setPaymentStatus', false);
                                store.commit('setPaymentErrors', response.data.errors);
                            }

                            store.commit('setThreeDSecureInProgress', false);
                            store.commit('setPaymentInProgress', false);
                            executing = false;
                        });
                    } else if (response.data.result.status === 'failed') {
                        store.commit('setPaymentInProgress', false);
                        store.commit('setPaymentStatus', false);
                        store.commit('setThreeDSecureInProgress', false);
                        executing = false;
                        store.commit('setPaymentErrors', response.data.result.errors);
                    } else { //if (response.data.result.status === 'pending') {
                        //release timer lock
                        executing = false;
                    }

                    //release watching thread if we don't have the transaction active
                    if (!store.state.bookingInfo.payment.threeDSecureInProgress) {
                        //stop watching thread 
                        window.clearInterval(store.state.stripeThreeDSecureTimer);
                        store.state.stripeThreeDSecureTimer = null;
                    }
                });
            },
                1000);
        },
        updateConfiguration: function (store) {
            console.log("booking load price");
            ApiService.getWebsiteSettings(store.state.configuration.apiKey).then((response) => {
                if (!response.data.success) { return; }

                store.commit('setWebsiteConfiguration', response.data.result);
            }).catch(error => {
                console.log("updateConfiguration call failed", error);
            });
        }
        //goToPrevStep(context) { },
        //saveStateAndGoToBookingPage: function (store) {
        //    //begin price loading
        //    //store.state.bookingInfo.general.isPriceLoading = true;
        //    //store.state.bookingInfo.general.loadPricesFromServer = true;
        //    ////save current state
        //    //var bookingState = store.state.bookingInfo;
        //    //localStorage.setItem('bookingInfoGeneral', JSON.stringify(bookingState));
        //    ////redirect to booking page 
        //    //window.location.href = "/booking";
        //}
    },
    getters: {
        currentStep: (state) => {
            return state.bookingInfo.currentStep;
        },
        isNotCoveredLocation: (state) => {
            return state.bookingInfo.general.isNotCoveredLocation;
        },
        companyName: (state) => {
            return state.configuration.companyName;
        },
        companyTermsAndCondHtml: (state) => {
            return state.configuration.companyTermsAndCondHtml;
        }
    },
    mutations: {
        initializeStore(state) {
            // Check if the saved state exists. This is used in case of a redirect
            var generalState = null;// window.localStorage.getItem('bookingInfoGeneral');
            if (generalState) {
                //restore state after a redirect
                var stateObj = JSON.parse(generalState);
                state.bookingInfo = stateObj;
                //make sure we remove loading indicator from step 1
                state.bookingInfo.general.isPriceLoading = false;

                //maybe remove item from cache
                //window.localStorage.setItem('bookingInfoGeneral', null)
            }
        },
        setNextRedirect: (state, data) => {
            state.nextRedirect = data;
        },
        setCurrentStep: (state, data) => {
            state.bookingInfo.currentStep = data;
        },
        setBookingType: (state, data) => {
            state.bookingInfo.general.bookingType = data;
            state.bookingInfo.mapInfo = Object.assign({}, state.bookingInfo.mapInfo, { type: data });
        },
        setPickupLocation: (state, data) => {
            state.bookingInfo.general.pickupAddress.text = data.text;
            state.bookingInfo.general.pickupAddress.location = data.location;
            state.bookingInfo.mapInfo.from = data.location.latLng;
            state.bookingInfo.mapInfo = Object.assign({}, state.bookingInfo.mapInfo, { from: data.location });
        },
        setDropoffLocation: (state, data) => {
            state.bookingInfo.general.dropOffAddress.text = data.text;
            state.bookingInfo.general.dropOffAddress.location = data.location;
            state.bookingInfo.mapInfo.to = data.location.latLng;
            state.bookingInfo.mapInfo = Object.assign({}, state.bookingInfo.mapInfo, { to: data.location });
        },
        setPickupDate: (state, data) => {
            state.bookingInfo.general.pickupDate = data;
        },
        setPickupTime: (state, data) => {
            state.bookingInfo.general.pickupTime = data;
        },
        setBookingPricesAreLoading: (state, data) => {
            state.bookingInfo.general.isPriceLoading = data;
        },
        setDurationInHours: (state, data) => {
            state.bookingInfo.general.durationInHours = data;
        },
        setTimeInMinutes: function(state, data) {
            state.bookingInfo.general.timeInMinutes = data;
        },
        setDistanceInMeters: function (state, data) {
            var miles = Math.round(data / 1609);
            state.bookingInfo.general.distanceInMiles = miles;
        }, 
        setSelectedCar: function(state, data) {
            state.bookingInfo.selectedCar = data;
            if (data) state.bookingInfo.currentStep = 3;
        }, 
        setPassengerDetailsEmail: function (state, data) {
            state.bookingInfo.passengerDetails.email = data;
        },
        setPassengerDetailsProperty: function (state, data) {
            var name = data.propertyName;
            state.bookingInfo.passengerDetails[name] = data.value;
        },
        setStripeSource: function(state, data) {
            state.bookingInfo.payment.stripeSource = data;
        },
        setStripeToken: function (state, data) {
            state.bookingInfo.payment.stripeToken = data;
        },
        setBookingGuid: function(state, data) {
            state.bookingInfo.general.guid = data;
        },
        setPaymentInfo: function (state, data) {
            state.bookingInfo.payment.errors = data.paymentErrors;
            state.bookingInfo.payment.done = data.paymentDone;
            state.bookingInfo.payment.stripeThreeDSecureUrl = data.stripeThreeDSecureUrl;
            state.bookingInfo.payment.stripeThreeDSecureSourceId = data.stripeThreeDSecureSourceId;
            if (state.bookingInfo.payment.done && state.bookingInfo.general.guid)
                state.bookingInfo.currentStep = 5;
        },
        setPaymentStatus: function(state, data) {
            state.bookingInfo.payment.done = data;
            if (state.bookingInfo.payment.done && state.bookingInfo.general.guid)
                state.bookingInfo.currentStep = 5;
        },
        setPaymentInProgress: function (state, data) {
            state.bookingInfo.payment.paymentInProgress = data;
        },
        setIsCreateBookingInProgress: function (state, data) {
            state.uiState.isCreateBookingInProgress = data;
        },
        setThreeDSecureInProgress: function (state, data) {
            state.bookingInfo.payment.threeDSecureInProgress = data;
        },
        setPaymentErrors: function(state, data) {
            state.bookingInfo.payment.errors = data;
        },
        setPriceLoading: function (state, data) {
            state.bookingInfo.general.isPriceLoading = data;
        },
        setServerPriceErrors: function (state, data) {
            state.bookingInfo.general.serverPriceErrors = data;
        },
        setNotCoveredLocation: function(state, data) {
            state.bookingInfo.general.isNotCoveredLocation = data;
        },
        setShowContactForm: function(state, data) {
            state.otherForms.showCustomQuoteForm = data;
        },
        setShowCustomerContactForm: function (state, data) {
            state.otherForms.showCustomerContactFormModal = data;
        },
        setShowTermsAndCondModal: function (state, data) {
            state.otherForms.showTermsAndCondModal = data;
        },
        setPromoCode: function(state, data) {
            state.bookingInfo.general.promoCode = data;
        },
        setBookingPaymentMethod: function (state, data) {
            state.bookingInfo.general.paymentMethod = data;
        },
        setWebsiteConfiguration: function (state, data) {
            state.configuration.stripeId = data.stripeKey;
            state.configuration.country = data.country;
            state.configuration.percentageToChargeAtBookingTime = data.percentageToChargeAtBookingTime;
            state.configuration.saveCustomerCardForLaterCharges = data.saveCustomerCardForLaterCharges;
            state.configuration.canConfirmByPhone = data.canConfirmByPhone;
            state.configuration.canConfirmByCash = data.canConfirmByCash;
        }
    }
});